/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_Case_2Inputs */

const en_how_we_work_check_case_2 = /** @type {(inputs: How_We_Work_Check_Case_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A missing price`)
};

const lv_how_we_work_check_case_2 = /** @type {(inputs: How_We_Work_Check_Case_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trūkst cenas`)
};

/**
* | output |
* | --- |
* | "A missing price" |
*
* @param {How_We_Work_Check_Case_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_case_2 = /** @type {((inputs?: How_We_Work_Check_Case_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_Case_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_case_2(inputs)
	return en_how_we_work_check_case_2(inputs)
});